import React from 'react';
import IconButton from '../../IconButton/IconButton';
import { SKIN_PRIORITY_MAP } from '../constants';
const Control = ({ dataHook, className, onClick, icon, size, skin = 'standard', disabled = false, }) => (React.createElement(IconButton, { dataHook: dataHook, className: className, onClick: onClick, size: size, skin: skin, disabled: disabled, priority: SKIN_PRIORITY_MAP[skin] }, icon));
export default Control;
//# sourceMappingURL=Control.js.map